import React from "react";
import { useFetchTemplatesMessage } from "../hooks/useFetchTemplatesMessage";
import { useNavigate } from "react-router-dom";
import TableMessageTemplates from "./TableMessageTemplates";
import { Tooltip } from "../../../../components/ui/Tooltip";
const _MessageTemplates = () => {
  const {
    data,
    isLoading,
    isRefetching,
    refetch: refetchTemplates,
  } = useFetchTemplatesMessage();
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex justify-end my-2 gap-2">
        <Tooltip message={"Ir a la creación de campañas"} placement={"top"}>
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/Campaigns/NewCampaignRcs")}
          >
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined">campaign</span>
              <span className="font-semibold">Campañas</span>
            </div>
          </button>
        </Tooltip>
        <button
          className={"btn btn-primary "}
          onClick={() => navigate("/rcs/MessageTemplates/create")}
        >
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined">add</span>
            <span className="font-semibold">Crear</span>
          </div>
        </button>
      </div>
      <div className="bg-white px-2 py-2 rounded-lg">
        <div>
          <TableMessageTemplates
            data={data}
            isLoading={isLoading || isRefetching}
            refetchTemplates={refetchTemplates}
          />
        </div>
      </div>
    </div>
  );
};

export default _MessageTemplates;
